import React, { useState } from 'react';
import styles from './DpgTemplatePicker.module.css';
import AnimateHeight from 'react-animate-height';
import { useHistory, useLocation } from 'react-router-dom';

function DpgTemplatePicker(props) {
  const [selectOpen, setSelectOpen] = useState(false);

  const location = useLocation();
  const history = useHistory();

  // Filter to only show Automated Page Takeover (1800x1000) - exclude Billboard Full Video variant
  const filteredTemplates = Object.entries(props.templateData || {}).filter(([templateNameKey, templateData]) => {
    // Check if the long name matches exactly "Automated Page Takeover (1800x1000)"
    const nameMatch =
      templateData.long_template_name &&
      templateData.long_template_name.toLowerCase().includes('skin billboard') &&
      templateData.long_template_name.toLowerCase().includes('970x1000') &&
      !templateData.long_template_name.toLowerCase().includes('full video') &&
      !templateData.long_template_name.toLowerCase().includes('video reminder');

    return nameMatch;
  });

  const templatesToShow = filteredTemplates;

  return (
    <div>
      <div className={styles.customSelectDropdown}>
        <div
          className={styles.toggleDropdownButton}
          onClick={() => {
            setSelectOpen((prevState) => !prevState);
          }}
        >
          <span className={styles.dropdownText}>{props.selectedFormat ? 'Skin billboard/ APTO (970x1000)' : 'Select a template'}</span>
          <span className={`${styles.dropdownArrow} } ${selectOpen === true ? styles.active : null}`}>
            <i className="fas fa-chevron-down"></i>
          </span>
        </div>
        <AnimateHeight duration={500} height={selectOpen ? 'auto' : 0}>
          <div className={`${styles.dropdownContent} ${selectOpen === true ? styles.open : null}`}>
            {templatesToShow.map(([templateNameKey, templateData]) => {
              return (
                <span
                  key={templateNameKey}
                  onClick={(event) => {
                    history.push(`${location.pathname}?format=${templateNameKey}`);
                    setSelectOpen(false);
                  }}
                >
                  Skin billboard/ APTO (970x1000)
                </span>
              );
            })}
          </div>
        </AnimateHeight>
      </div>
    </div>
  );
}

export default DpgTemplatePicker;
